import React from 'react';

import { Box, Stack } from '@lyearn/ui';

import { FrequencyComponentProps } from '../../../types';
import TimeOfDay from '../../InputComponents/TimeOfDay';
import IntervalInput from './CustomInputComponents/IntervalInput';
import CustomFrequencyInput from './CustomFrequencyInput';

const CustomDay: React.FC<FrequencyComponentProps> = React.memo((props) => {
  const { value, onChange, hideTimeSelection, disabled, allowedCustomFrequencies, size } = props;

  return (
    <Stack alignItems="center" justifyContent="start">
      <Box className="flex w-1/2 flex-row items-center space-s-8">
        <IntervalInput disabled={disabled} size={size} value={value} onChange={onChange} />
        <CustomFrequencyInput
          allowedCustomFrequencies={allowedCustomFrequencies}
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
        />
      </Box>
      {hideTimeSelection ? null : (
        <TimeOfDay
          className="flex flex-1"
          disabled={disabled}
          size={size}
          value={value}
          onChange={onChange}
        />
      )}
    </Stack>
  );
});

export default CustomDay;
